import identity from "./identity.js";
import uniqBy from "./uniqBy.js";
var uniq = uniqBy(identity);
export default uniq;
